import { Product } from "src/app/api/models";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RetrieveService } from "src/app/api/services";
import { ProductService } from "src/app/shared/services/product.service";
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { collectExternalReferences } from "@angular/compiler";
import { ClientService } from "src/app/api/services/client.service";
import { Address } from "src/app/api/models/address";
import { Order } from "src/app/api/models/order";
import { OrderType } from "src/app/api/models/order-type";

declare var toastr: any;

@Component({
  selector: "app-product-detail",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
})


export class CheckoutComponent implements OnInit {

  profileForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
    telephone: new FormControl('', Validators.pattern('[- +()0-9]+')),
    street: new FormControl('', Validators.required),
    house_number: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    province: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zip_code: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9]{5}')]))
  });

  cartProducts: Product[];
  totalValue: number;
  defaultWarehouseId = 1;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    public productService: ProductService,
    private fb: FormBuilder,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.getCartProduct();
    this.profileForm.get('state').setValue('Italia');
  }

  getCartProduct() {
    this.cartProducts = this.productService.getLocalCartProducts();
    this.totalValue = 0;
    this.cartProducts.forEach((product) => {
      this.totalValue += product.price * this.productService.getProductQuantity(product.product_id)
    });
  }

  onSubmit() {
    console.log(this.profileForm.value)
    let address: Address = {
      city: this.profileForm.get('city').value,
      house_number: this.profileForm.get('house_number').value,
      state: this.profileForm.get('state').value,
      zip_code: this.profileForm.get('zip_code').value,
      province: this.profileForm.get('province').value,
      street: this.profileForm.get('street').value,
    }

    let productIds = []
    let quantities = []
    this.cartProducts.forEach((product) => {
      productIds.push(product.product_id)
      quantities.push(this.productService.getProductQuantity(product.product_id))
    });



    let order: Order = {
      email: this.profileForm.get('email').value,
      first_name: this.profileForm.get('firstName').value,
      telephone: this.profileForm.get('telephone').value,
      last_name: this.profileForm.get('lastName').value,
      address: address,
      product_ids: productIds,
      quantities: quantities,
      warehouse_id: this.defaultWarehouseId,
      order_type: OrderType.Purchase,
      total: this.totalValue
    }


    this.clientService.placeOrder({ body: order }).subscribe(
      () => {
        toastr.success('Il tuo ordine è stato preso in carico. </br> Ti abbiamo inviato una mail di conferma. </br> Verrai contattato al più presto! ', 'Conferma Ordine!', {
          closeButton: true,
          "positionClass": "toast-top-full-width"
        });
        this.productService.emptyCart();
        setTimeout(() => {
          this.router.navigate(['/']);
        },
          2000);
      },
      (err) => {
        console.log(err.error.message)
        let error_message = ''
        if(err.error.code == 409){
          error_message = err.error.message
        }
        toastr.error(error_message, "ERRORE!", {
          closeButton: true,
          "positionClass": "toast-top-full-width"
        });
      }
    )
  }
}
